import React, {useState, useEffect, useRef} from 'react';
import RecommendedVideos from './RecommendedVideos';
import ProductsSeenInVideo from './ProductsSeenInVideo';
import useResize from '../hooks/useResize';
import VideoInstructor from './VideoInstructor';
import PropTypes from 'prop-types';
const VideoMetaData = ({ selectedVideo, isPromo = false }) => {
	const instructor = selectedVideo?.instructorDetails?.[0];
	const hasValidInstructor =
	instructor &&
	(instructor.bio || (Array.isArray(instructor.socials) ? instructor.socials.length > 0 : Object.keys(instructor.socials || {}).length > 0));


	return (
		<React.Fragment>
			<div className="c-video_description-data">
				<VideoDescriptionText description={selectedVideo?.description} />
				{hasValidInstructor && (
					<VideoInstructor instructorData={instructor} />
				)}
			</div>
			<div className="c-video-content-section">
				<div className="c-video-wrapper">
					{selectedVideo && (
						<RecommendedVideos
							selectedVideo={selectedVideo}
							isPromo={isPromo}
							skipClasses={isPromo}
							recommendedTextOverride={isPromo ? 'Explore Related Videos' : ''}
						/>
					)}
					<ProductsSeenInVideo products={selectedVideo?.productsData} customeStyles={{width:"fit-content"}} />
				</div>
			</div>
		</React.Fragment>
	);
};


const VideoDescriptionText = ({ description }) => {
	const deviceType = useResize();
	const [expanded, setExpanded] = useState(false);
	const [isOverflowing, setIsOverflowing] = useState(false);

	const descRef = useRef(null);

	const checkOverflow = () => {
		const descElement = descRef.current;
		if (descElement) {
			const style = window.getComputedStyle(descElement);
			const lineHeight = parseFloat(style.lineHeight);

			const totalLines = Math.round(descElement.scrollHeight / lineHeight);
			const visibleLines = Math.round(descElement.clientHeight / lineHeight);

			const isContentOverflowing = totalLines > visibleLines;
			setIsOverflowing(isContentOverflowing);
		}
	};

	useEffect(() => {
		checkOverflow();
		window.addEventListener('resize', checkOverflow);
		return () => window.removeEventListener('resize', checkOverflow);
	}, [description, deviceType]);

	return (
		<div className={`description-container ${expanded ? 'expanded' : ''}`}>
			<div className={`c-video_description-text`}>
				<p
					className="description"
					ref={descRef}
					
					dangerouslySetInnerHTML={{ __html: description || '' }}
				></p>

				
				{deviceType === 'mobile' && isOverflowing && (
					<button className="view-more-btn-mobile" onClick={() => setExpanded(!expanded)}>
						{expanded ? 'Show Less' : 'More'}
					</button>
				)}

				{deviceType !== 'mobile' && isOverflowing && (
					<button className="view-more-btn" onClick={() => setExpanded(!expanded)}>
						{expanded ? 'Show Less' : 'More'}
					</button>
				)}
			</div>
		</div>
	);
}

VideoDescriptionText.propTypes = {
	description: PropTypes.string
};

export default VideoMetaData;
